import { useFormikContext } from "formik";
import { useMemo } from "react";
import useInvoicePaymentSummary from "./useInvoicePaymentSummary";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
export default function useInvoicePaymentModalSummary(param) {
    var payment = param.payment;
    var totalToBePaid = useInvoicePaymentSummary().totalToBePaid;
    var values = useFormikContext().values;
    var modalInvoiceModalState = useInvoiceInitContext().modalInvoiceModalState;
    var modalInvPayment = modalInvoiceModalState.modalInvPayment, setModalInvPayment = modalInvoiceModalState.setModalInvPayment;
    var paymentRows = payment.factNewInvPaymentRow || [];
    var adjustments = payment.factNewInvAdjustmentOrFee || [];
    var sumRowsInModal = useMemo(function() {
        return paymentRows.reduce(function(acc, row) {
            return acc + (Number(row.price) || 0);
        }, 0);
    }, [
        payment
    ]);
    var sumAdjustmentsInModal = useMemo(function() {
        return adjustments.reduce(function(acc, adj) {
            return acc + (Number(adj.price) || 0);
        }, 0);
    }, [
        payment
    ]);
    var sumPaymentInModal = useMemo(function() {
        return sumRowsInModal + sumAdjustmentsInModal;
    }, [
        sumRowsInModal,
        sumAdjustmentsInModal
    ]);
    var totalToBePaidInModal = useMemo(function() {
        if (modalInvPayment.modeInv === "create") {
            return totalToBePaid - sumPaymentInModal;
        } else {
            var _values_factNewInvPayment;
            var original = values === null || values === void 0 ? void 0 : (_values_factNewInvPayment = values.factNewInvPayment) === null || _values_factNewInvPayment === void 0 ? void 0 : _values_factNewInvPayment[modalInvPayment.paymentIndex];
            console.log("paymentIndex", modalInvPayment.paymentIndex);
            console.log("original", original);
            var originalSum = sumOfPaymentItem(original); // ฟังก์ชันรวม original
            return totalToBePaid - (sumPaymentInModal - originalSum);
        }
    }, [
        sumPaymentInModal,
        totalToBePaid,
        modalInvPayment.modeInv,
        modalInvPayment.paymentIndex
    ]);
    function sumOfPaymentItem(payment) {
        if (!payment) return 0;
        var rows = payment.factNewInvPaymentRow || [];
        var adjustments = payment.factNewInvAdjustmentOrFee || [];
        var rowSum = rows.reduce(function(sum, row) {
            return sum + (Number(row.price) || 0);
        }, 0);
        var adjustmentSum = adjustments.reduce(function(sum, adj) {
            return sum + (Number(adj.price) || 0);
        }, 0);
        return rowSum + adjustmentSum;
    }
    return {
        sumPaymentInModal: sumPaymentInModal,
        sumRowsInModal: sumRowsInModal,
        sumAdjustmentsInModal: sumAdjustmentsInModal,
        totalToBePaidInModal: totalToBePaidInModal
    };
}
